import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Caution } from "@xfrontend/xui-react-plus";
import i18n from "#/i18n";

const CustomCaution = styled(Caution)`
  > span:first-of-type {
    bottom: 84px;
  }
`;

type CmpState = {
  error: boolean;
};

class ErrorBoundary extends PureComponent<Record<string, unknown>, CmpState> {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static getDerivedStateFromError(error: { stack: string }): Record<string, unknown> {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  constructor(props: { children: JSX.Element }) {
    super(props);
    this.state = { error: false };
  }

  render(): JSX.Element {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <div
          id="commonErrorBoundary"
          className="d-flex justify-content-center"
          style={{ width: "100%", height: "100%" }}
        >
          <CustomCaution
            style={{ marginTop: "150px" }}
            number={i18n.t("common:errorBoundary.title")}
            msg={i18n.t("common:errorBoundary.message")}
          />
        </div>
      );
    }
    return children as JSX.Element;
  }
}

export default ErrorBoundary;
